import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';
import FilterBar from '../common/FilterBar';
import { STATUSES } from '../../config/constants';

const allStatuses = Object.values(STATUSES);

const StudentFilters = ({ filters = {}, onChange, onClear }) => {
  const handleChange = (field) => (event) => {
    onChange({ ...filters, [field]: event.target.value });
  };

  const hasActiveFilters = Object.values(filters).some(
    (v) => v !== '' && v !== null && v !== undefined
  );

  return (
    <FilterBar onClear={hasActiveFilters ? onClear : undefined}>
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="status-filter-label">Status</InputLabel>
        <Select
          labelId="status-filter-label"
          value={filters.status || ''}
          label="Status"
          onChange={handleChange('status')}
        >
          <MenuItem value="">
            <em>All Statuses</em>
          </MenuItem>
          {allStatuses.map((status) => (
            <MenuItem key={status} value={status}>
              {status}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Country"
        value={filters.country || ''}
        onChange={handleChange('country')}
        sx={{ minWidth: 150 }}
      />

      <TextField
        size="small"
        label="Bank"
        value={filters.interestedBank || ''}
        onChange={handleChange('interestedBank')}
        sx={{ minWidth: 150 }}
      />
    </FilterBar>
  );
};

export default StudentFilters;
